import * as projectsList from '@/store/Projects/index'
import * as usersListProjects from '@/store/Users/index'
import * as clientsListProjects from '@/store/Clients/index'
import * as stepsList from '@/store/Steps/index'
import * as timer from '@/store/Timer/index'
import * as reminders from '@/store/Reminders/index'
import * as requestsList from '@/store/Requests/index'
import * as currentTab from '@/store/ActiveTabs/index'
import * as queryProjects from '@/store/QueryProjects/index'

const modules = {}

Object.assign(modules, projectsList.modules)
Object.assign(modules, usersListProjects.modules)
Object.assign(modules, clientsListProjects.modules)
Object.assign(modules, stepsList.modules)
Object.assign(modules, requestsList.modules)
Object.assign(modules, currentTab.modules)
Object.assign(modules, queryProjects.modules)
Object.assign(modules, timer.modules)
Object.assign(modules, reminders.modules)

export default modules



// WEBPACK FOOTER //
// ./src/store/storeModulesList.js